module.exports = __webpack_public_path__ + "static/img/planet-left.dee9d72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/planet-left.png
// module id = 1502
// module chunks = 0